import $ from "jquery";
import Constants from "../business/Constants";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import { SmartComponent } from "smart-component-js";
import moment from "moment";

class DefaultCtrl extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.init();
  }
  init() {
    const { CLOSING_STEP_1_DATE } = Constants;
    this.loadChildComponents(this);

    if (moment(CLOSING_STEP_1_DATE, "DD/MM/YYYY HH:mm").diff(moment()) < 0) {
      $(".closingStep1").show();
    } else {
      $(".beforeClosing").show();
    }
  }

  goToPlayReceipt() {
    window.location.href = "/promozioni/vinci-il-buongiorno/gioca-scontrino";
  }
}

export default DefaultCtrl;
